import CustomLottie from '@/components/custom-lottie';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { useContext, useEffect } from 'react';

const PaymentSuccess = (props: { onBack: () => void }) => {
  const { event } = useContext(SoundContext);
  useEffect(() => {
    event.playPaymentSuccess();
  }, []);

  return (
    <div className="relative flex size-full flex-col items-center bg-success">
      <div className="m-auto flex max-w-[480px] flex-col items-center justify-center gap-6">
        <CustomLottie
          path="/images/lotties/successful.json"
          className="size-[180px] overflow-hidden rounded-full border border-solid border-white"
          onLoadComplete={props.onBack}
        />
        <h2 className="flex-none text-[32px] font-bold text-white">
          Payment Successful!
        </h2>
      </div>
    </div>
  );
};
export default PaymentSuccess;
